import React from 'react'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'

import Input from 'components/shared/Input'

interface IProps {
  handleLogin: (username: string, password: string) => void
  forgotPassword: () => void
  error: string
}

interface IState {
  username: string
  password: string
}

class LoginScreen extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props)
    this.state = {
      username: '',
      password: '',
    }
  }

  _handleUsernameChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      ...this.state,
      username: evt.currentTarget.value.trim(),
    })
  }

  _handlePasswordChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      ...this.state,
      password: evt.currentTarget.value,
    })
  }

  _handleLogin = async event => {
    const { username, password } = this.state
    event.preventDefault()
    this.props.handleLogin(username, password)
  }

  render() {
    const { username, password } = this.state
    const { error, forgotPassword } = this.props
    return (
      <form name="login" onSubmit={this._handleLogin}>
        <Grid container direction="column" spacing={3} style={{ backgroundColor: '#fff' }}>
          <Box p={{ xs: 2, md: 4, lg: 6 }}>
            <Grid item>
              <Input label="Username" value={username} onChange={this._handleUsernameChange} />
            </Grid>
            <Grid item>
              <Input label="Password" type="password" value={password} onChange={this._handlePasswordChange} />
            </Grid>
            <Grid item>
              <Box mt={{ xs: 2, md: 5 }}>
                <Button fullWidth variant="contained" type="submit" disabled={!username || !password}>
                  <Typography variant="h4" color="primary">
                    Sign In
                  </Typography>
                </Button>
              </Box>
            </Grid>
            <Grid container item justify="center">
              <Box mt={{ xs: 2, md: 5 }}>
                <Typography variant="h4" color="secondary" onClick={forgotPassword}>
                  Forgot your password?
                </Typography>
              </Box>
            </Grid>
            {error && (
              <Box mt={{ xs: 2 }}>
                <Typography variant="h4" color="error">
                  {error}
                </Typography>
              </Box>
            )}
          </Box>
        </Grid>
      </form>
    )
  }
}

export default LoginScreen
